<template>
<div class="sideBar_ui" :style="bgPicStyle">
    <div class="sideBar_box" :class="[{open:isOpen=='T'}]" v-if="datas.style=='one'">
        <div class="sideBar_box_info">
            <div class="logo" v-if="datas.logo">
                <img :src="datas.logo">
            </div>
            <div class="sideBar_item" :style="itemStyle" v-for="(item,i) in datas.items" :key="i" @click="goPage(item)">
                <div class="tl" v-if="datas.item=='doubleText'||datas.item=='singleLine'">
                    {{item.name}}
                </div>
                <div class="tl" v-if="datas.item=='icon'&&item.logo">
                    <img :src="item.logo">
                </div>
                <div class="desc" v-if="datas.item!='singleLine'">{{item.desc}}</div>
            </div>
            <div class="sideBar_btn" @click="openClose()" v-if="datas.show&&datas.style == 'one'">
                <div class="sideBar_btn_box" :style="txtStyle" v-if="isOpen=='T'"><i class="iconfont iconshouqi"></i>收起</div>
                <div class="sideBar_btn_box" :style="txtStyle" v-else><i class="iconfont iconzhankai1"></i>展开</div>
                <div class="bg" :style="bgStyle"></div>
            </div>
        </div>
        <div class="bg" :style="bgStyle"></div>
    </div>
    <div class="sideBar_box_two" v-if="datas.style=='two'&&canShow=='T'">
        <div class="sideBar_left">
            <div class="sideBar_item" :style="itemStyle+item.style" v-for="(item,i) in datas.items" :key="i" @click="goPage(item)" v-if="i%2==0">
                <div class="tl" v-if="datas.item=='doubleText'||datas.item=='singleLine'">
                    {{item.name}}
                </div>
                <div class="tl" v-if="datas.item=='icon'&&item.logo">
                    <img :src="item.logo">
                </div>
                <div class="desc" v-if="datas.item!='singleLine'">
                    <div class="txt">{{item.desc}}</div>
                    <i class="iconfont icongengduo1"></i>
                </div>
            </div>
            <div class="bg" :style="bgStyle"></div>
        </div>
        <div class="sideBar_right" :class="{'dislocation':datas.display=='2'}">
            <div class="sideBar_item" :style="itemStyle+item.style" v-for="(item,i) in datas.items" :key="i" @click="goPage(item)" v-if="i%2==1">

                <div class="tl" v-if="datas.item=='doubleText'||datas.item=='singleLine'">
                    {{item.name}}
                </div>
                <div class="tl" v-if="datas.item=='icon'&&item.logo">
                    <img :src="item.logo">
                </div>
                <div class="desc" v-if="datas.item!='singleLine'">
                   
                    <div class="txt"><i class="iconfont icongengduo1"></i>{{item.desc}}</div>
                </div>
            </div>
            <div class="bg" :style="bgStyle"></div>
        </div>

    </div>
    <div class="rotate_btn" v-if="datas.style=='two'&&datas.rotateInto&&animation=='F'" @click="intoSideBar">
        <div class="rotate_btn_box">
            <img class="rotate_img" src="https://xcx.ihotel.cn/mall/images/rotate_bg.gif">
            <div class="rotate_logo" v-if="datas.rotateIntoPic">
                <img :src="datas.rotateIntoPic">
            </div>
            <p>点击进入</p>
        </div>
    </div>
   
    <div class="bgPic" :style="bgPicStyle" :class="{'bgPic_animation':animation=='T','bgPic_leftRightMove':moveAnimation=='T'}" v-if="datas.bgPic"></div>
</div>
</template>

<script>
export default {
    data() {
        return {
            isOpen: 'T', //单侧展开收起
            canShow: 'F', //展示双侧栏
            animation: 'F', //旋转按钮点击进入
            moveAnimation:'F'
        };
    },
    props: ["datas"],
    computed: {
        bgPicStyle() {
            var style = ''
            style = `background: url(${this.datas.bgPic}) center 0/cover no-repeat;`
           
            return style
        },
        txtStyle() {
            var style = ''
            style = `color:${this.datas.textColor};`
            return style
        },
        itemStyle() {
            var style = ''
            style = `margin-top:${this.datas.spacing}px;font-size:${this.datas.textSize}px;color:${this.datas.textColor};`
            return style
        },
        bgStyle() {
            var style = ''
            style = `background:${this.datas.background};color:${this.datas.textColor};`
            return style

        },

    },
    methods: {
        goPage(item) {
            if (item.link) {
                window.location.href = item.link
            }
        },
        openClose() {
            if (this.isOpen == 'T') {
                this.isOpen = 'F'
            } else {
                this.isOpen = 'T'
            }
        },
        animationBar(delay) {
            if (this.datas.items && this.datas.style == 'two') {
                this.animation = 'T'
                var d = 0
                if (delay && delay == 'T') {
                    d = 2000
                }
                setTimeout(() => {
                    this.canShow = 'T'
                }, d);
                this.datas.items.forEach((item, i) => {
                    if (this.datas.animation == '2') {
                        var time = 0.5
                        this.$set(item, 'style', `animation-delay:${time*i}s`)
                    }
                });
            }

        },
        intoSideBar() {
            this.animationBar('T')
        }
    },
    mounted() {
        if (!this.datas.rotateInto && this.datas.style == 'two') {
            this.animationBar()
        }
        if(this.datas.style=='one'){
            this.moveAnimation ='T'
        }

    }

};
</script>

<style lang="less" scoped>
@import url("~@/styles/mixin.less");

.sideBar_ui {
    
    .bgPic {
        position: fixed;
        height: 100vh;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 3;
        &.bgPic_leftRightMove{

            width: calc(100% + 60px);
            transform: translateX(-30px);
            animation: leftRightMove 10s infinite linear;
        }
        &.bgPic_animation {
            animation: enlarge2 2s;
            animation-fill-mode: forwards;
        }

    }

    .sideBar_box {
        position: fixed;
        z-index: 9;
        top: 0;
        left: -4rem;
        width: 4rem;
        height: 100vh;
        line-height: 1.4;

        transition: all 0.2s;

        .sideBar_box_info {
            padding: 0.533333rem 0;
            height: 100%;
            overflow-y: scroll;
        }

        .bg {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -1;
            opacity: 0.5;
        }

        &.open {
            left: 0;
        }

        .logo {
            text-align: center;
            margin-bottom: 1.226667rem;

            img {
                max-width: 80%;
            }
        }

        .sideBar_item {
            .tl {
                font-family: PingFangSC-Regular;
                text-align: center;

                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                white-space: normal;
                overflow: hidden;

                img {
                    max-height: 0.586667rem;
                    margin-bottom: 0.133333rem;
                }

            }

            .desc {
                font-family: PingFangSC-Regular;
                font-size: 13px;
                height: 0.48rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                white-space: normal;
                overflow: hidden;
                text-align: center;
            }
        }

        .sideBar_btn {
            display: flex;
            align-items: center;
            position: absolute;
            right: 0;
            top: 50%;
            overflow: hidden;
            padding: 0 0.266667rem;
            transform: translate(100%, -100%);
            border-radius: 0px 100px 100px 0px;
            font-family: SourceHanSansCN-Medium;
            font-size: 14px;
            height: 1.066667rem;

            .sideBar_btn_box {
                display: flex;
                align-items: center;

                i {
                    font-size: 10px;
                    margin-right: 0.106667rem;
                    line-height: 0.533333rem;
                }
            }

        }
    }

    .rotate_btn {
        position: absolute;
        left: 50%;
        top: 50%;
        z-index: 9;
        transform: translate(-50%, -50%);

        .rotate_btn_box {
            animation: enlarge 1s;
            animation-fill-mode: forwards;
        }

        .rotate_img {
            width: 160px;
            height: 160px;

        }

        p {
            margin-top: 20px;
            font-size: 16px;
            color: #FFFFFF;
            text-align: center;
        }

        .rotate_logo {
            position: absolute;
            top: 40px;
            left: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 80px;
            height: 80px;

            img {
                max-height: 100%;
                max-width: 100%;
            }
        }

    }

    .sideBar_box_two {
        position: fixed;
        z-index: 8;
        top: 0;
        width: 100%;
        height: 100vh;
        line-height: 1.4;

        .bg {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            z-index: -1;
            opacity: 0.5;
        }

        .sideBar_item {
            position: relative;
            opacity: 0;

            .tl {
                font-family: PingFangSC-Regular;

                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                white-space: normal;
                overflow: hidden;

                img {
                    max-height: 0.586667rem;
                    margin-bottom: 0.133333rem;
                }

            }

            .desc {
                font-family: PingFangSC-Regular;
                font-size: 13px;
                height: 18px;
                display: flex;
                align-items: center;

                .txt {
                    display: -webkit-box;
                    height: 18px;
                    line-height: 18px;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    white-space: normal;
                    overflow: hidden;
                    word-break: break-all;

                }

                i {
                    font-size: 8px;
                }

            }
        }

        .sideBar_left {
            padding: 0.5rem 0.4rem 0.5rem;
            box-sizing: border-box;
            position: fixed;
            z-index: 8;
            top: 0;
            left: 0;
            width: 4rem;
            height: 100vh;
            line-height: 1.4;

            .sideBar_item {
                left: 0;
                animation: leftMove 1s;
                animation-fill-mode: forwards;
                text-align: left;

                .icongengduo1 {
                    margin-left: 1px;
                    line-height: 13px;

                    &::before {
                        vertical-align: middle;
                    }
                }
            }

        }

        .sideBar_right {
            position: fixed;
            padding: 0.5rem 0.4rem 0.5rem;
            box-sizing: border-box;
            z-index: 8;
            top: 0;
            right: 0;
            width: 4rem;
            height: 100vh;
            line-height: 1.4;

            .sideBar_item {
                left: 0;
                animation: rightMove 1s;
                animation-fill-mode: forwards;
                text-align: right;

                .desc {
                    justify-content: flex-end;

                    .icongengduo1 {
                        transform: rotate(180deg);
                        line-height: 18px;
                        height: 18px;
                        display: inline-block;
                        vertical-align: top;
                        margin-right: 1px;
                       
                    }
                }

            }

            &.dislocation {
                .sideBar_item {
                    transform: translateY(43px);

                }

            }
        }
    }
    @keyframes leftRightMove {

        0% {
            left: -30px;
        }
        25% {
            left: 0px;
        }
        50% {
            left: 30px;
        }
        75%  {
            left: 0;
        }
        100%  {
            left: -30px;
        }

    }
    @keyframes leftMove {

        from {
            left: 120px;
            opacity: 0;
        }

        to {
            left: 0;
            opacity: 1;
        }

    }

    @keyframes rightMove {

        from {
            left: -120px;
            opacity: 0;
        }

        to {
            left: 0;
            opacity: 1;
        }

    }

    @keyframes enlarge {

        from {
            transform: scale(0.8);
        }

        to {
            transform: scale(1);
        }

    }

    @keyframes enlarge2 {

        from {
            transform: scale(1);
        }

        to {
            transform: scale(1.2);
        }

    }

}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/sideBar.vue